import { render, staticRenderFns } from "./DialogWorkInfo.vue?vue&type=template&id=3c71b3e2&scoped=true"
import script from "./DialogWorkInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogWorkInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DialogWorkInfo.vue?vue&type=style&index=0&id=3c71b3e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c71b3e2",
  null
  
)

export default component.exports